const secondaryPalette$2 = {
  camelotLight: '#FEEFF3',
  camelotBase: '#EECAD3',
  camelotDark: '#E0A2B3',
  camelotDarken: '#91364E',
  pomegranateLight: '#FAC4BF',
  pomegranateBase: '#F4766B',
  pomegranateDark: '#F14F41',
  pomegranateDarken: '#EF2917',
  capriSunLight: '#FFEFD9',
  capriSunBase: '#FFBE69',
  capriSunDark: '#FFAB3E',
  capriSunDarken: '#FF9914',
  marinerLight: '#EBF7FB',
  marinerBase: '#9FCEE9',
  marinerDark: '#52AFE3',
  marinerDarken: '#2370B7',
  indigoLight: '#E8EEFD',
  indigoBase: '#A1B2E0',
  indigoDark: '#6C87CF',
  indigoDarken: '#5046C2',
  amethystLight: '#F4EAF8',
  amethystBase: '#E4CAEE',
  amethystDark: '#D0A3E1',
  amethystDarken: '#B46CCF',
  grayLight: '#FAFAFA'
};
const themeUiStates$2 = {
  success: '#046720',
  info: '#2D5A9D',
  error: '#DE350B'
};
const lightTheme = {
  illustrations: 'light',
  overlay: 'rgba(0, 0, 0, 0.4)',
  breakpoints: {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
  },
  disable: {
    opacity: 0.5
  },
  borderRadius: {
    none: 0,
    round: 1000,
    base: 8,
    large: 16
  },
  backgroundColors: {
    primary: '#FFFFFF',
    secondary: '#046720',
    elevated: '#FFFFFF'
  },
  borderColors: Object.assign({
    none: 'none',
    transparent: 'transparent',
    primary: '#E0E0E0',
    secondary: '#595959',
    tertiary: '#046720',
    quaternary: '#FFFFFF',
    quinary: '#A8A8A8'
  }, themeUiStates$2),
  borderWidths: {
    none: 0,
    base: 1,
    large: 2
  },
  shapeFills: Object.assign(Object.assign({
    transparent: 'transparent',
    primary: '#000000',
    secondary: '#046720',
    tertiary: '#595959',
    quaternary: '#AFAFAF',
    quinary: '#EEEEEE',
    senary: '#FFFFFF',
    septenary: '#FFFFFF'
  }, themeUiStates$2), secondaryPalette$2),
  colors: Object.assign(Object.assign({
    primary: '#1E1E1E',
    secondary: '#FFFFFF',
    tertiary: '#046720',
    quaternary: '#595959',
    quinary: '#AFAFAF',
    senary: '#1E1E1E',
    danger: '#EF2917'
  }, themeUiStates$2), secondaryPalette$2),
  spacings: {
    none: 0,
    xTiny: 4,
    tiny: 8,
    xSmall: 12,
    small: 16,
    medium: 20,
    base: 24,
    large: 28,
    xLarge: 32,
    xxLarge: 40,
    xxxLarge: 56,
    xxxxLarge: 72
  },
  boxShadows: {
    none: 'none',
    base: '0px 1px 6px rgba(0, 0, 0, 0.08)',
    dark: '0px 1px 8px rgba(0, 0, 0, 0.14)',
    darken: '0px 1px 10px rgba(0, 0, 0, 0.2)'
  },
  typographies: {
    'headline-1': {
      fontSize: 48,
      lineHeight: 64,
      fontFamily: 'Gilroy',
      fontWeight: 800
    },
    'headline-2': {
      fontSize: 22,
      lineHeight: 32,
      fontFamily: 'Gilroy',
      fontWeight: 700
    },
    jumbo: {
      fontSize: 36,
      lineHeight: 42,
      fontFamily: 'Poppins',
      fontWeight: 600
    },
    'headline-3': {
      fontSize: 17,
      lineHeight: 24,
      fontFamily: 'Gilroy',
      fontWeight: 600
    },
    'body-1': {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 400
    },
    'body-2': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 400
    },
    'label-1': {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'label-2': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 600
    },
    'label-3': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'caption-1': {
      fontSize: 12,
      lineHeight: 16,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'caption-2': {
      fontSize: 10,
      lineHeight: 16,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'section-title': {
      fontSize: 28,
      lineHeight: 32,
      fontFamily: 'Gilroy',
      fontWeight: 700
    }
  },
  zIndices: {
    sticky: 5,
    bottomSheet: 8,
    modal: 10
  }
};

const secondaryPalette$1 = {
  camelotLight: '#FEEFF3',
  camelotBase: '#EECAD3',
  camelotDark: '#E0A2B3',
  camelotDarken: '#91364E',
  pomegranateLight: '#FAC4BF',
  pomegranateBase: '#F4766B',
  pomegranateDark: '#F14F41',
  pomegranateDarken: '#EF2917',
  capriSunLight: '#FFEFD9',
  capriSunBase: '#FFBE69',
  capriSunDark: '#FFAB3E',
  capriSunDarken: '#FF9914',
  marinerLight: '#EBF7FB',
  marinerBase: '#9FCEE9',
  marinerDark: '#52AFE3',
  marinerDarken: '#2370B7',
  indigoLight: '#E8EEFD',
  indigoBase: '#A1B2E0',
  indigoDark: '#6C87CF',
  indigoDarken: '#5046C2',
  amethystLight: '#F4EAF8',
  amethystBase: '#E4CAEE',
  amethystDark: '#D0A3E1',
  amethystDarken: '#B46CCF',
  grayLight: '#FAFAFA'
};
const themeUiStates$1 = {
  success: '#4FC366',
  info: '#7FB0FA',
  error: '#FF6C42'
};
const darkTheme = {
  illustrations: 'dark',
  overlay: 'rgba(0, 0, 0, 0.4)',
  breakpoints: {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
  },
  disable: {
    opacity: 0.5
  },
  borderRadius: {
    none: 0,
    round: 1000,
    base: 8,
    large: 24
  },
  backgroundColors: {
    primary: '#1E1E1E',
    secondary: '#4FC366',
    elevated: '#2F2F32'
  },
  borderColors: Object.assign({
    none: 'none',
    transparent: 'transparent',
    primary: '#373737',
    secondary: '#A8A8A8',
    tertiary: '#4FC366',
    quaternary: '#FFFFFF',
    quinary: '#404040'
  }, themeUiStates$1),
  borderWidths: {
    none: 0,
    base: 1,
    large: 2
  },
  shapeFills: Object.assign(Object.assign({
    transparent: 'transparent',
    primary: '#FFFFFF',
    secondary: '#4FC366',
    tertiary: '#A8A8A8',
    quaternary: '#808080',
    quinary: '#404040',
    senary: '#1E1E1E',
    septenary: '#FFFFFF'
  }, themeUiStates$1), secondaryPalette$1),
  colors: Object.assign(Object.assign({
    primary: '#FFFFFF',
    secondary: '#FFFFFF',
    tertiary: '#4FC366',
    quaternary: '#A8A8A8',
    quinary: '#808080',
    senary: '#1E1E1E',
    danger: '#EF2917'
  }, themeUiStates$1), secondaryPalette$1),
  spacings: {
    none: 0,
    xTiny: 4,
    tiny: 8,
    xSmall: 12,
    small: 16,
    medium: 20,
    base: 24,
    large: 28,
    xLarge: 32,
    xxLarge: 40,
    xxxLarge: 56,
    xxxxLarge: 72
  },
  boxShadows: {
    none: 'none',
    base: '0px 1px 6px rgba(0, 0, 0, 0.08)',
    dark: '0px 1px 8px rgba(0, 0, 0, 0.14)',
    darken: '0px 1px 10px rgba(0, 0, 0, 0.2)'
  },
  typographies: {
    'headline-1': {
      fontSize: 48,
      lineHeight: 64,
      fontFamily: 'Gilroy',
      fontWeight: 800
    },
    'headline-2': {
      fontSize: 22,
      lineHeight: 32,
      fontFamily: 'Gilroy',
      fontWeight: 700
    },
    jumbo: {
      fontSize: 36,
      lineHeight: 42,
      fontFamily: 'Poppins',
      fontWeight: 600
    },
    'headline-3': {
      fontSize: 17,
      lineHeight: 24,
      fontFamily: 'Gilroy',
      fontWeight: 600
    },
    'body-1': {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 400
    },
    'body-2': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 400
    },
    'label-1': {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'label-2': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 600
    },
    'label-3': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'caption-1': {
      fontSize: 12,
      lineHeight: 16,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'caption-2': {
      fontSize: 10,
      lineHeight: 16,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'section-title': {
      fontSize: 28,
      lineHeight: 32,
      fontFamily: 'Gilroy',
      fontWeight: 700
    }
  },
  zIndices: {
    sticky: 5,
    bottomSheet: 8,
    modal: 10
  }
};

const secondaryPalette = {
  camelotLight: '#FEEFF3',
  camelotBase: '#EECAD3',
  camelotDark: '#E0A2B3',
  camelotDarken: '#91364E',
  pomegranateLight: '#FAC4BF',
  pomegranateBase: '#F4766B',
  pomegranateDark: '#F14F41',
  pomegranateDarken: '#EF2917',
  capriSunLight: '#FFEFD9',
  capriSunBase: '#FFBE69',
  capriSunDark: '#FFAB3E',
  capriSunDarken: '#FF9914',
  marinerLight: '#EBF7FB',
  marinerBase: '#9FCEE9',
  marinerDark: '#52AFE3',
  marinerDarken: '#2370B7',
  indigoLight: '#E8EEFD',
  indigoBase: '#A1B2E0',
  indigoDark: '#6C87CF',
  indigoDarken: '#5046C2',
  amethystLight: '#F4EAF8',
  amethystBase: '#E4CAEE',
  amethystDark: '#D0A3E1',
  amethystDarken: '#B46CCF',
  grayLight: '#FAFAFA'
};
const themeUiStates = {
  success: '#046720',
  info: '#2D5A9D',
  error: '#DE350B'
};
const kyteTheme = {
  illustrations: 'light',
  overlay: 'rgba(0, 0, 0, 0.4)',
  breakpoints: {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
  },
  disable: {
    opacity: 0.5
  },
  borderRadius: {
    none: 0,
    round: 1000,
    base: 8,
    large: 16
  },
  backgroundColors: {
    primary: '#FFFFFF',
    secondary: '#046720',
    elevated: '#FFFFFF'
  },
  borderColors: Object.assign({
    none: 'none',
    transparent: 'transparent',
    primary: '#E0E0E0',
    secondary: '#595959',
    tertiary: '#046720',
    quaternary: '#FFFFFF',
    quinary: '#A8A8A8'
  }, themeUiStates),
  borderWidths: {
    none: 0,
    base: 1,
    large: 2
  },
  shapeFills: Object.assign(Object.assign({
    transparent: 'transparent',
    primary: '#000000',
    secondary: '#046720',
    tertiary: '#595959',
    quaternary: '#AFAFAF',
    quinary: '#EEEEEE',
    senary: '#FFFFFF',
    septenary: '#FFFFFF'
  }, themeUiStates), secondaryPalette),
  colors: Object.assign(Object.assign({
    primary: '#1E1E1E',
    secondary: '#FFFFFF',
    tertiary: '#046720',
    quaternary: '#595959',
    quinary: '#AFAFAF',
    senary: '#1E1E1E',
    danger: '#EF2917'
  }, themeUiStates), secondaryPalette),
  spacings: {
    none: 0,
    xTiny: 4,
    tiny: 8,
    xSmall: 12,
    small: 16,
    medium: 20,
    base: 24,
    large: 28,
    xLarge: 32,
    xxLarge: 40,
    xxxLarge: 56,
    xxxxLarge: 72
  },
  boxShadows: {
    none: 'none',
    base: '0px 1px 6px rgba(0, 0, 0, 0.08)',
    dark: '0px 1px 8px rgba(0, 0, 0, 0.14)',
    darken: '0px 1px 10px rgba(0, 0, 0, 0.2)'
  },
  typographies: {
    'headline-1': {
      fontSize: 48,
      lineHeight: 64,
      fontFamily: 'Gilroy',
      fontWeight: 800
    },
    'headline-2': {
      fontSize: 22,
      lineHeight: 32,
      fontFamily: 'Gilroy',
      fontWeight: 700
    },
    jumbo: {
      fontSize: 36,
      lineHeight: 42,
      fontFamily: 'Poppins',
      fontWeight: 600
    },
    'headline-3': {
      fontSize: 17,
      lineHeight: 24,
      fontFamily: 'Gilroy',
      fontWeight: 600
    },
    'body-1': {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 400
    },
    'body-2': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 400
    },
    'label-1': {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'label-2': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 600
    },
    'label-3': {
      fontSize: 14,
      lineHeight: 20,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'caption-1': {
      fontSize: 12,
      lineHeight: 16,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'caption-2': {
      fontSize: 10,
      lineHeight: 16,
      fontFamily: 'Hanken Grotesk',
      fontWeight: 500
    },
    'section-title': {
      fontSize: 28,
      lineHeight: 32,
      fontFamily: 'Gilroy',
      fontWeight: 700
    }
  },
  zIndices: {
    sticky: 5,
    bottomSheet: 8,
    modal: 10
  }
};

export { darkTheme as d, kyteTheme as k, lightTheme as l };
//# sourceMappingURL=kyte-15420865.js.map
